import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GetUom_Class } from '../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupUomClass = () => {
  const dispatch = useDispatch();

  const { i18n } = useTranslation();

  useEffect(() => {
    if (UOM_CLASS?.length === 0) {
      dispatch(GetUom_Class());
    }
  }, []);

  const { UOM_CLASS, loading, error } = useSelector((state) => state.Lookup);

  const UOMCLASSOPTIONS = UOM_CLASS?.map((item, idx) =>
    item.list?.map((list) => ({
      label: i18n.language === 'en' ? list.meaning : list.meaning2,
      value: list.lookupCode,
    }))
  );

  return { UOM_CLASS, UOMCLASSOPTIONS, loading, error };
};

export default useLookupUomClass;
